module.exports = __webpack_public_path__ + "static/img/tim-logo.d148ce48.png";